import type {VideoJsPlayer} from 'video.js';

import {safeAccess} from '../../utils/objectUtils';

export class VideojsPlayerProxy {
  constructor(private readonly rawPlayer: VideoJsPlayer) {}

  on = (...args: Parameters<VideoJsPlayer['on']>) => {
    safeAccess(() => this.rawPlayer.on(...args));
  };

  ready = (...args: Parameters<VideoJsPlayer['ready']>) => safeAccess(() => this.rawPlayer.ready(...args));

  duration = () => safeAccess(() => this.rawPlayer.duration());

  currentTime = () => safeAccess(() => this.rawPlayer.currentTime());

  currentSrc = () => safeAccess(() => this.rawPlayer.currentSrc());

  currentType = () => safeAccess(() => this.rawPlayer.currentType());

  autoplay = () => safeAccess(() => this.rawPlayer.autoplay());

  muted = () => safeAccess(() => this.rawPlayer.muted());

  height = () => safeAccess(() => this.rawPlayer.height());

  width = () => safeAccess(() => this.rawPlayer.width());

  videoHeight = () => safeAccess(() => this.rawPlayer.videoHeight());

  videoWidth = () => safeAccess(() => this.rawPlayer.videoWidth());

  isFullscreen = () => safeAccess(() => this.rawPlayer.isFullscreen());

  audioTracks = () => safeAccess(() => this.rawPlayer.audioTracks());

  tech = (options?: unknown) => safeAccess(() => this.rawPlayer.tech(options));

  version = () => safeAccess(() => this.rawPlayer.version?.());
}
